<template lang="">
  <q-table
    title=""
    :rows="subscriptions"
    :columns="columnDefinition"
    :pagination="pagination"
    row-key="id"
    :rows-per-page-options="[]"
  >
    <template #body="props">
      <q-tr :props="props">
        <q-td key="title" :props="props">
          {{ props.row.title }}
        </q-td>        
        <q-td key="price" :props="props">
          {{ props.row.price }}
        </q-td>
        <q-td key="regional_loss" :props="props">
          {{ props.row.limits["REGIONAL_LOSS"] }}
        </q-td>
        <q-td key="regime_session" :props="props">
          {{ props.row.limits["REGIME_SESSION"] }}
        </q-td> 
        <q-td key="actions" :props="props">
          <div class="q-pa-md q-gutter-sm">
            <EditSubscription :subscription="props.row" />
            <DeleteSubscription :subscription-id="props.row.id" />
          </div>
        </q-td>
      </q-tr>
    </template>
  </q-table>
</template>

<script>
import EditSubscription from './Edit.vue'
import DeleteSubscription from './Delete.vue'
import * as columns from '../../utils/columns'
import { ref } from 'vue'

export default {
  components: {
    EditSubscription,
    DeleteSubscription,
  },
  props: {
    subscriptions: Object,
  },
  setup() {
    const columnDefinition = columns.SUBSCRIPTION_COLUMNS
    const pagination = ref({
      page: 1,
      rowsPerPage: 100,
      rowsNumber: 0,
    })

    return {
      pagination,
      columnDefinition,
    }
  },
}
</script>
